// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/53a412eb26d354b7a70c.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"8bab0c5557673ea79865","216":"c411fe352eb5320d381f","217":"a75e4a901017d4b31b44"}[chunkId] + ".chunk.js";
};